import HideAssemblyMaterials from './HideAssemblyMaterials';

export default HideAssemblyMaterials;